import { httpsCallable } from 'firebase/functions';
import { functions } from '../config';
import type { PatternHistoryAccuracyStats } from '../../../utils/pattern/accuracyCalc';

/**
 * パターン精度集計レスポンス。
 * stats のキーは pattern_history_id（履歴なしレガシーは __no_history__）。
 */
export interface AggregatePatternAccuracyResponse {
  success: boolean;
  stats: Record<string, PatternHistoryAccuracyStats>;
}

/**
 * パターン精度集計 Callable。
 * クライアント側 N+1（result ごとに ocr_executions / result_history を取得）を
 * 回避するため、Functions 側で集計してから結果のみ返す。
 * issue #2828 で一般ユーザー（自社パターンのみ）にも開放。
 */
export const aggregatePatternAccuracy = async (
  patternId: string,
): Promise<AggregatePatternAccuracyResponse> => {
  const callable = httpsCallable<{ pattern_id: string }, AggregatePatternAccuracyResponse>(
    functions,
    'aggregatePatternAccuracy',
  );
  const result = await callable({ pattern_id: patternId });
  return result.data;
};
